var arr =  [{
  newPermission: 'mh!rms!dis',
  url: "/fangT",
  title: '房态'
}, {
  newPermission: 'mh!rmde!dis',
  url: "/fangQ",
  title: '房情'
},{
  newPermission: 'mh!resrv!dis',
  url: "/book",
  title: '预定'
},{
  newPermission: 'mh!resrvlist!dis',
  url: "/orderList",
  title: '订单列表'
},{
  newPermission: 'mh!smcrms!dis',
  url: "/cityState",
  title: '同城房态'
},{
  newPermission: 'mh!pos!dis',
  url: "/cateringOrder",
  title: '餐饮订单'
},{
  newPermission: 'mh!cag!dis',
  url: "/meetingOrder",
  title: '会议订单'
},{
  newPermission: 'mh!event!dis',
  url: "/eventWorm",
  title: '事件预警'
},{
  newPermission: 'mh!newsicon!dis',
  url: "/pushMessageList",
  title: '消息通知'
},{
  newPermission: 'mh!pay!cre',
  url: "/anypay/anypay",
  title: '任意付'
},{
  newPermission: 'mh!member!new',
  url: "/memberRegister",
  title: '会员注册'
},{
  newPermission: 'mh!member!list',
  url: "/memberSearch",
  title: '会员查询'
},{
  newPermission: 'mh!member!check',
  url: "/CouponUse",
  title: '卡券核销'
},{
  newPermission: 'mh!reven!compa',
  url: "/revenueCompare",
  title: '营收对比'
},{
  newPermission: 'mh!reven!sta',
  url: "/revenueReport",
  title: '营收情况'
},{
  newPermission: 'mh!account!dis',
  url: "/cashierReport",
  title: '收款情况'
},{
  newPermission: 'mh!checkout!sta',
  url: "/payReport",
  title: '结账情况'
},{
  newPermission: 'mh!guest!res',
  url: "/orderFromReport",
  title: '客源情况'
},{
  newPermission: 'mh!rm!pre',
  url: "/roomPrediectionReport",
  title: '房类预测'
},{
  newPermission: 'mh!member!dev',
  url: "/member",
  title: '会员发展'
},{
  newPermission: 'mh!shift!dis',
  url: "/shirtReport",
  title: '交班报表'
},{
  newPermission: 'mh!member!compa',
  url: "/memberContrast",
  title: '会员对比'
},{
  newPermission: 'mh!member!ind',
  url: "/memberSingleContrast",
  title: '会员指标'
},{
  newPermission: 'mh!member!sta',
  url: "/memberMoreHotelContrast",
  title: '会员状况'
},{
  newPermission: 'mh!floor!sta',
  url: "/RmtypeFloor",
  title: '房类楼层'
},{
  newPermission: 'mh!reven!daily',
  url: "/system/reportView?code=up_ihotel_rep_jour",
  title: '营业日报'
},{
  newPermission: 'mh!reven!rge',
  url: "/system/reportViewR?code=test1",
  title: '营业日报范围'
},{
  newPermission: 'mh!reven!ind',
  url: "/system/reportView?code=test2",
  title: 'crs指标'
},]

export default arr



// WEBPACK FOOTER //
// ./src/conf/newPermissionIcon.js